module.exports = __webpack_public_path__ + "static/media/Gemma.ff81871a.png";